import React from "react";

import {
  FiAlertTriangle,
  FiBell,
  FiGrid,
  FiInbox,
  FiMessageSquare,
} from "react-icons/fi";

import {
  cn,
  formatNumber,
} from "../utils/siteActivityFormatters";

export default function SiteActivityFamilyTabs({
  options,
  activeFamily,
  onChange,
}) {
  if (!options?.length) {
    return null;
  }

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-6">
      {options.map((option) => {
        const active =
          option.value ===
          activeFamily;

        const alerts =
          Number(
            option.notifications ||
              0,
          ) +
          Number(
            option.messages || 0,
          );

        return (
          <button
            key={option.value}
            type="button"
            onClick={() =>
              onChange(
                option.value,
              )
            }
            className={cn(
              "group rounded-[22px] border p-4 text-left transition",
              active
                ? "border-[#2EA7E0] bg-[#EEF8FD] shadow-sm ring-2 ring-[#2EA7E0]/10 dark:border-sky-500 dark:bg-sky-950/30"
                : "border-slate-200 bg-white hover:border-sky-200 hover:bg-slate-50 dark:border-slate-800 dark:bg-slate-900 dark:hover:border-slate-700 dark:hover:bg-slate-800/70",
            )}
          >
            <div className="flex items-start justify-between gap-3">
              <div
                className={cn(
                  "flex h-10 w-10 items-center justify-center rounded-2xl",
                  active
                    ? "bg-[#2EA7E0] text-white"
                    : "bg-slate-100 text-slate-500 group-hover:bg-sky-100 group-hover:text-sky-600 dark:bg-slate-800 dark:text-slate-300",
                )}
              >
                <FiGrid />
              </div>

              <div className="rounded-full bg-slate-100 px-2.5 py-1 text-xs font-bold text-slate-600 dark:bg-slate-800 dark:text-slate-300">
                {formatNumber(
                  option.sites,
                )}
              </div>
            </div>

            <div className="mt-3">
              <div
                className={cn(
                  "font-bold",
                  active
                    ? "text-[#123B57] dark:text-sky-100"
                    : "text-slate-700 dark:text-slate-100",
                )}
              >
                {option.label}
              </div>

              <div className="mt-3 flex flex-wrap gap-1.5">
                {alerts > 0 && (
                  <span className="inline-flex items-center gap-1 rounded-full bg-rose-50 px-2 py-1 text-[11px] font-bold text-rose-600 dark:bg-rose-950/40 dark:text-rose-300">
                    <FiBell />
                    {alerts}
                  </span>
                )}

                {option.notifications >
                  0 && (
                  <span
                    className="hidden"
                    title="Notifications"
                  >
                    <FiBell />
                  </span>
                )}

                {option.messages >
                  0 && (
                  <span className="inline-flex items-center gap-1 rounded-full bg-sky-50 px-2 py-1 text-[11px] font-bold text-sky-600 dark:bg-sky-950/40 dark:text-sky-300">
                    <FiMessageSquare />
                    {
                      option.messages
                    }
                  </span>
                )}

                {option.requests >
                  0 && (
                  <span className="inline-flex items-center gap-1 rounded-full bg-amber-50 px-2 py-1 text-[11px] font-bold text-amber-600 dark:bg-amber-950/40 dark:text-amber-300">
                    <FiInbox />
                    {
                      option.requests
                    }
                  </span>
                )}

                {option.warnings >
                  0 && (
                  <span className="inline-flex items-center gap-1 rounded-full bg-orange-50 px-2 py-1 text-[11px] font-bold text-orange-600 dark:bg-orange-950/40 dark:text-orange-300">
                    <FiAlertTriangle />
                    {
                      option.warnings
                    }
                  </span>
                )}

                {alerts === 0 &&
                  option.requests ===
                    0 &&
                  option.warnings ===
                    0 && (
                    <span className="text-xs font-medium text-slate-400">
                      Aucune
                      alerte
                    </span>
                  )}
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
}